export default "/images/triangle.svg?a3999de48b7f01fc860df3c0fe3e6a5b";